<template>
<div>账户</div>
</template>

<script>
export default {
name: "account"
}
</script>

<style scoped>

</style>
